import { Typography, styled } from "@material-ui/core";

export const InputFieldNameText = styled(Typography)({
  color: "#2E3860",
  fontFamily: "'Inter', 'sans-serif'",
  fontSize: "14px",
  fontWeight: 400,
  // Dark mode (additive): only applies under the `.dark` root; light unchanged.
  "html.dark &": {
    color: "hsl(var(--sds-foreground))",
  },
});
